<script setup lang="ts">
import { isFilled } from '@prismicio/client'
import type { Content } from "@prismicio/client";

defineProps(getSliceComponentProps<Content.StepProcessSlice>());
</script>

<template>
  <section
      :data-slice-type="slice.slice_type"
      :data-slice-variation="slice.variation"
      class="pa-steps"
  >
    <div class="pa-container">
      <div class="pa-steps__header">
        <p v-if="slice.primary.tagline" class="pa-steps__tagline">
          {{ slice.primary.tagline }}
        </p>
        <div v-if="isFilled.richText(slice.primary.mainTitle)" class="pa-steps__heading">
          <PrismicRichText :field="slice.primary.mainTitle" />
        </div>
        <div v-if="isFilled.richText(slice.primary.description)" class="pa-steps__description">
          <PrismicRichText :field="slice.primary.description" />
        </div>
      </div>

      <ol v-if="slice.primary.steps?.length" class="pa-steps__list">
        <li
            v-for="(step, index) in slice.primary.steps"
            :key="index"
            class="pa-steps__item"
        >
          <span class="pa-steps__item-number" aria-hidden="true">{{ index + 1 }}</span>
          <h3 v-if="step.title" class="pa-steps__item-title">{{ step.title }}</h3>
          <div v-if="isFilled.richText(step.description)" class="pa-steps__item-description">
            <PrismicRichText :field="step.description" />
          </div>
        </li>
      </ol>
    </div>
  </section>
</template>
